/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { CriteriaCourseWorklist } from '../../models/criteria-course-worklist';

export interface ApiReportExportCouresReportPost$Params {
      body?: CriteriaCourseWorklist
}

export function apiReportExportCouresReportPost(http: HttpClient, rootUrl: string, params?: ApiReportExportCouresReportPost$Params, context?: HttpContext): Observable<StrictHttpResponse<string>> {
  const rb = new RequestBuilder(rootUrl, apiReportExportCouresReportPost.PATH, 'post');
  if (params) {
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<string>;
    })
  );
}

apiReportExportCouresReportPost.PATH = '/api/Report/ExportCouresReport';
